export const SEARCH = 'search';
export const PAGE = 'page';
export const PER_PAGE = 'per_page';
export const DATE_PERIOD = 'date_period';
export const QUERY_FIELD = 'query_field';
export const QUERY_TYPE = 'query_type';
export const NOT_REDIRECT = 'not_redirect';
